// utils/InitInterceptors.js
import { useEffect } from 'react';
import { useLoading } from '../context/LoadingContext';
import { attachLoadingInterceptors } from '../api/axios';

const InitInterceptors = () => {
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    attachLoadingInterceptors(startLoading, stopLoading);
  }, []);

  return null;
};

export default InitInterceptors;
